import { BaseResource } from './base-resource';
import { ContactPerson } from './contact-person';
import { NestedGeneric } from './nested-generic';
import { Profile } from './profile';
import { FileValue } from './file-value';

export enum PropertyType { RESELLER = 'reseller', CLIENT = 'client', MAIN = 'main',}

export interface PropertyConfig {
  sendAlerts: boolean;
  sendInvoicing: boolean;
  daysLatePayment: boolean;
  timezone: string;
  distanceUnit: string;
  speedUnit: string;
}

export interface PropertyPersonalize {
  theme?: string;
  logotype?: FileValue;
  invertLogotype?: FileValue;
  loginBackground?: FileValue;
  favicon?: FileValue;
  invertFavicon?: FileValue;
  nameOwn: string;
  mode?: string;
  primaryColor?: string;
  navColoring?: boolean;
  headerColoring?: boolean;
  logotypeColoring?: boolean;
}

export interface Property extends BaseResource {
  name: string;
  type: PropertyType;
  disable: boolean;
  agent: ContactPerson;
  config?: PropertyConfig;
  personalize: PropertyPersonalize;
  features: [];
  propertyId?: string;
  userId?: string;
  profileIds?: string[];
  own?: NestedGeneric;
  profiles?: Profile[];
  mobiles?: Array<NestedGeneric>;
}
